<div class="input-container" [style.width]="width + '%'">
  <textarea
    [class.disabled]="formControl.disabled"
    [formControl]="formControl"
    [attr.aria-label]="ariaLabel"
    [placeholder]="placeholder ?? ''"
    cdkTextareaAutosize
  ></textarea>
  <div class="counter">{{ charCounter }}</div>
  <app-error-message *ngIf="formControl.errors && formControl.touched" [validationErrors]="formControl.errors"></app-error-message>
</div>
